import { render } from "./BankCollectedAddBatchDetail.vue?vue&type=template&id=70b9d39f&scoped=true"
import script from "./BankCollectedAddBatchDetail.vue?vue&type=script&lang=js"
export * from "./BankCollectedAddBatchDetail.vue?vue&type=script&lang=js"

import "./BankCollectedAddBatchDetail.vue?vue&type=style&index=0&id=70b9d39f&scoped=true&lang=less"

import exportComponent from "D:\\Project\\远创人力\\开发\\前端\\yc_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70b9d39f"]])

export default __exports__